var WISHLIST_KEY = 'shopify-wishlist';

function getWishlist() {
  try {
    return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
  } catch (e) {
    return [];
  }
}

function setWishlist(list) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  window.dispatchEvent(new CustomEvent('wishlist:change', { detail: { count: list.length } }));
}

function toggleWishlistItem(handle) {
  var list = getWishlist();
  var idx = list.indexOf(handle);
  if (idx > -1) {
    list.splice(idx, 1);
  } else {
    list.push(handle);
  }
  setWishlist(list);
  return idx === -1;
}

function isInWishlist(handle) {
  return getWishlist().indexOf(handle) > -1;
}

if (!customElements.get('wishlist-button')) {
  customElements.define('wishlist-button', class extends HTMLElement {
    connectedCallback() {
      this.handle = this.dataset.handle;
      this._updateState();

      this._onClick = this._onClick.bind(this);
      this.addEventListener('click', this._onClick);

      this._onWishlistChange = this._updateState.bind(this);
      window.addEventListener('wishlist:change', this._onWishlistChange);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      window.removeEventListener('wishlist:change', this._onWishlistChange);
    }

    _onClick(e) {
      e.preventDefault();
      var added = toggleWishlistItem(this.handle);
      this._updateState();
    }

    _updateState() {
      var active = isInWishlist(this.handle);
      var svg = this.querySelector('svg path');
      if (svg) {
        svg.setAttribute('fill', active ? 'currentColor' : 'none');
      }
      this.setAttribute('aria-pressed', active);
    }
  });
}

if (!customElements.get('wishlist-count')) {
  customElements.define('wishlist-count', class extends HTMLElement {
    connectedCallback() {
      this._update();
      this._onWishlistChange = this._update.bind(this);
      window.addEventListener('wishlist:change', this._onWishlistChange);
    }

    disconnectedCallback() {
      window.removeEventListener('wishlist:change', this._onWishlistChange);
    }

    _update() {
      var count = getWishlist().length;
      this.textContent = count;
      this.classList.toggle('hidden', count === 0);
    }
  });
}
